module.exports = __webpack_public_path__ + "img/dp_lp_pc_bg_2_pc.f744787b.jpg";